import React from "react";
import { Box, Button, IconButton } from "@mui/material";
import { State } from "@hookstate/core";
import { useLang } from "~/hooks/useLang";
import useUserState from "~/features/User/stores/UserState";
import { FilterNoneOutlined, LibraryAddCheckOutlined, MobileOff } from "@mui/icons-material";
import type { IListDeviceSocket } from "../../interfaces/IListDevicesprops";
import { MoveDown } from '@mui/icons-material';
import useListDevicesSocket from "../../stores/ListDevicesSocketState";

interface ActionsMultipleDeviceButtonProps {
  readonly tab: string;
  readonly rowsSelected: readonly IListDeviceSocket[];
  readonly enableCheckbox: boolean;
  readonly enableButtonShowResume: boolean;
  readonly openModalResultMultipleDisconnectDevice: State<boolean>;
  readonly openModalResultMultipleTransferDevice: State<boolean>;
  readonly openDialogTransferMultiple: State<boolean>;
  readonly handleClickOpen: () => void;
  readonly handleCheckBox: () => void;
}

export default function ActionsMultipleDeviceButton({ tab, rowsSelected, enableCheckbox, enableButtonShowResume, openModalResultMultipleDisconnectDevice, openModalResultMultipleTransferDevice, openDialogTransferMultiple, handleClickOpen, handleCheckBox }: ActionsMultipleDeviceButtonProps) { 
  const { translate } = useLang();
  const { verifyPermission } = useUserState()
  const { enableButtonShowResumeTransferMultiple } = useListDevicesSocket()

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 1,
        marginTop: 2
      }}
    >
      {
        verifyPermission(['device_disconnect_multiple']) &&
        window.location.pathname === '/dispatch/vehicles/list-full' &&
        <>
          <IconButton
            onClick={() => handleCheckBox()}
            title={enableCheckbox ? translate('Disable Select') : translate('Enable Select')}
            size="large"
          >
            {enableCheckbox ? <LibraryAddCheckOutlined fontSize='small' /> : <FilterNoneOutlined fontSize='small' />}
          </IconButton>
          {tab === 'available' &&
            <IconButton
              title={translate('Disconnect')}
              disabled={!rowsSelected.length || !enableCheckbox}
              onClick={() => handleClickOpen()}
              size="large"
            >
              <MobileOff fontSize='small' />
            </IconButton>
          }
          {tab === 'disconnected' && verifyPermission(['device_transfer_multiple']) &&
            <IconButton
              title={translate('Transfer')}
              disabled={(!rowsSelected.length ) || !enableCheckbox}
              onClick={() => handleClickOpen()}
              size="large"
            >
              <MoveDown fontSize='small' />
            </IconButton>
          }
        </>
      }
      {enableButtonShowResume && tab === 'available' &&
        window.location.pathname === '/dispatch/vehicles/list-full' &&
        <Button
          variant='text'
          onClick={() => openModalResultMultipleDisconnectDevice.set(true)}
          sx={{
            '&:hover': {
              textDecoration: 'underline',
              background: "none",
            },

          }}
        >
          {translate('Show resume disconnect multiple devices')}
        </Button>
      }
      {enableButtonShowResumeTransferMultiple.get() && tab === 'disconnected' &&
        window.location.pathname === '/dispatch/vehicles/list-full' &&
        <Button
          variant='text'
          onClick={() => openModalResultMultipleTransferDevice.set(true)}
          sx={{
            '&:hover': {
              textDecoration: 'underline',
              background: "none",
            },

          }}
        >
          {translate('View the last batch device transfer')}
        </Button>
      }
    </Box>
  )
}